<template>
  <label
    class="label label-md label-inline text-capitalize w-100"
    :class="`label-light-${homeStatus2Color(value)}`"
  >
    {{ value }}
  </label>
</template>

<script>
export default {
  name: "HomeStatusLabel",
  props: ["value"],
  methods: {
    homeStatus2Color(value) {
      let color = {
        ["Running"]: () => "warning",
        ["Succeeded"]: () => "success",
        ["Pending"]: () => "primary",
        ["Skipped"]: () => "danger",
        ["NotFound"]: () => "danger",
        ["Creating"]: () => "primary",
        ["Failed"]: () => "danger",
      };

      return color[value]();
    },
  },
};
</script>

<style></style>
